<template>
    <div>
        <modal
            :is-open="isOpen"
            :is-loading="loading"
            :disabled="loading"
            title="Выберите коллекцию"
            @onCloseModal="closeModal"
            @onSaveModal="saveModal"
        >
            <div v-if="productIds.length > 1">
                Выбрано изделий: {{ productIds.length }}
            </div>

            <div class="cabinet-form-group app-modal__list">
                <label class="custom-radio">
                    <input
                        v-model="massCollection"
                        type="radio"
                        name="collection"
                        value=""
                    />
                    <span class="custom-radio__checkmark"></span>
                    Нет коллекции
                </label>
            </div>
            <div
                v-for="collection in collectionsByBrand"
                :key="collection.CollectionID"
                class="cabinet-form-group app-modal__list"
            >
                <label class="custom-radio">
                    <input
                        v-model="massCollection"
                        type="radio"
                        name="collection"
                        :value="collection.CollectionID"
                    />
                    <span class="custom-radio__checkmark"></span>
                    {{ collection.Name }}
                </label>
                <div class="product-form-visibility__descr pt-0">
                    {{ getNameById(brands, 'BrandName', 'BrandID', brandId) }}
                </div>
            </div>

            <div class="cabinet-form-group">
                <button
                    type="button"
                    class="cabinet-btn  cabinet-btn--transparent cabinet-btn--add cabinet-btn--add-blue"
                    @click="onAddCollectionClick"
                >
                    Добавить коллекцию
                </button>
            </div>
        </modal>
    </div>
</template>

<script>
import Modal from '@/components/Elements/Modal'
import getNameById from '@/mixins/getNameById'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'ChangeCollectionMass',
    components: { Modal },
    mixins: [getNameById],
    props: {
        productIds: {
            type: Array,
            required: true
        },
        brandId: {
            // eslint-disable-next-line
            type: Number | String,
            default: ''
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            massCollection: ''
        }
    },
    computed: {
        ...mapState('supplierBrand', ['brands']),
        ...mapGetters('supplierCollections', ['getCollectionsByBrand']),
        ...mapGetters('supplierProducts', ['getProductKeyValue']),
        collectionsByBrand() {
            if (!this.brandId) return []
            return this.getCollectionsByBrand(this.brandId)
        }
    },
    watch: {
        isOpen: function(val) {
            if (val) {
                if (this.productIds.length === 1) {
                    this.massCollection =
                        this.getProductKeyValue(
                            this.productIds[0],
                            'CollectionID'
                        ) || ''
                }
            } else {
                this.massCollection = ''
            }
        }
    },
    methods: {
        ...mapActions('supplierProducts', ['updateProductsMass']),
        closeModal() {
            this.$emit('closeModal')
        },
        onAddCollectionClick() {
            this.$emit('onAddCollectionClick', 'changeCollectionMass')
        },
        async saveModal() {
            if (this.loading) return

            this.loading = true

            let data = {
                CollectionID: this.massCollection || null,
                Items: this.productIds
            }

            try {
                let payload = {
                    type: 'collection',
                    data
                }
                await this.updateProductsMass(payload)

                this.$notify({
                    title: 'Коллекция изделий изменена',
                    type: 'success'
                })

                this.$emit('onChangeCollectionMassSaved')
            } catch (e) {
                console.log(e)
                this.$notify({
                    title: 'Ошибка',
                    type: 'error'
                })
            }

            this.loading = false
            this.closeModal()
        }
    }
}
</script>
